// next.config.mjs sets `trailingSlash: true`, so the server 308-redirects every
// slashless URL to its trailing-slash form. Client-side navigation through the
// App Router does not apply that rule — router.push("/sg/book-trial") writes
// that exact string into history — so the same page reached by hard load and by
// in-app navigation reported two different pagePath values to GA4 (TD-127).
//
// Route every internal navigation through this helper so the address bar always
// matches the canonical server form.

const EXTERNAL_SCHEME = /^[a-z][a-z0-9+.-]*:/i;

export function canonicalPath(path: string): string {
    // Absolute URLs, mailto:, tel:, protocol-relative — not ours to rewrite.
    if (EXTERNAL_SCHEME.test(path) || path.startsWith("//")) {
        return path;
    }

    const queryIndex = path.search(/[?#]/);
    const pathname = queryIndex === -1 ? path : path.slice(0, queryIndex);
    const suffix = queryIndex === -1 ? "" : path.slice(queryIndex);

    if (pathname.endsWith("/")) {
        return path;
    }

    // Static assets under public/ are served at their literal path.
    const lastSegment = pathname.slice(pathname.lastIndexOf("/") + 1);
    if (lastSegment.includes(".")) {
        return path;
    }

    return `${pathname}/${suffix}`;
}
